'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './service-requests-list.routes';

export class ServiceRequestsListComponent {

  constructor(IntegrationService, Auth, dialogs, Config, $state, $uibModal, prompt) {
    'ngInject';
    this.baseContainerClass = Config.getPlatformConfig().getBaseContainerClass();
    this.Auth = Auth;
    this.dialogs = dialogs;
    this.$uibModal = $uibModal;
    this.prompt = prompt;
    this.integrationAvailable = true;
    this.IntegrationService = IntegrationService;

    this.pageTitle = Config.getPageTitleByStateWithDefault($state.current.name, "Service Requests");

    this.refreshData();
  }

  refreshData() {
    this.Auth.getCurrentUser(user => {
      this.userId = user._id;
      this.webaccessId = user.webaccessId;
      this.user = user;

      this.IntegrationService.test(result => {
        if (!result || !result.status || !result.status == 'successful') {
          this.integrationAvailable = false;
        } else {

          this.IntegrationService.queryServiceRequestsByWebaccessId({webaccessId: user.webaccessId}, data => {
            this.requests = data;
          });

        }
      })
    });
  }

  cancel(request) {
    this.prompt({
      title: 'Close Service Request',
      message: 'Please specify the reason below:',
      input: true,
      label: '',
      value: ''
    }).then(note => {

      let fullName = this.user.firstName + " " + this.user.lastName;

      let patches = [
        { "op": "add", "path": "/notes/-", "value": {note: "The service request has been closed by requester (owner): " + fullName} },
        { "op": "add", "path": "/status", "value": "closed" },
      ];

      if (note) {
        let noteObj = {
          note: note,
          firstName: this.user.firstName,
          middleName: this.user.middleName,
          lastName: this.user.lastName,
          meta: {
            webaccessUser: this.webaccessId
          }
        };

        patches.push({ "op": "add", "path": "/chat/-", "value": noteObj });
      }

      this.IntegrationService.patchServiceRequest({id: request._id}, patches, _ => {
        this.refreshData();
      });
    });
  }

  openServiceRequestInfoModal(ticket) {
    var that = this;

    var modalInstance = this.$uibModal.open({
      animation: true,
      component: 'serviceRequestInfoComponent',
      resolve: {
        config: function() {
          return {
            ticket
          }
        }
      },
      size: 'md'
    });

    modalInstance.result.then(
      function () {},
      function () { /* cancel */ }
    );

  }
}

export default angular.module('conduuApp.serviceRequests.list', [uiRouter])
  .config(routes)
  .component('serviceRequestsList', {
    template: require('./service-requests-list.html'),
    controller: ServiceRequestsListComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/service-requests/list/service-requests-list.component.js